<div class="mt-3 history-container" [ngClass]="tabType === 'history' ? 'w-50' : ''"
  (click)="tabType==='overview' ? switchTab() : ''">
  <div class="history-wrapper" [ngClass]="tabType === 'history' ? '' : 'cursor'" *ngFor="let item of historyData">
    <div class="d-flex gap-10 align-items-baseline">
      <span class="dot"></span>
      <span class="card-title">{{ item?.name }}</span>
      <span class="status body-font"
        [ngStyle]="{ 'background-color': item?.status?.bgColor, 'color': item?.status?.textColor, 'border': '1px solid ' + item?.status?.borderColor }">{{item?.status?.name}}</span>
    </div>
    <div class="mt-2 body-font" [ngClass]="tabType === 'history' ? '' : 'text-ellipsis'"
      [matTooltip]="tabType === 'history' ? '' : item?.description">
      {{item?.description}}
    </div>
    <div class="responsive-details mt-2 body-font">
      <div>{{item?.model}}</div>
      <div>{{item?.gen}}</div>
      <div>{{item?.date}}</div>
    </div>
  </div>
</div>